import { OutputId } from "../../idTypeBrands.js";
import { createAppSessionEventDefinition } from "../AppSessionEventDefinition.js";

export const DELETE_OUTPUT = createAppSessionEventDefinition({
  type: "DELETE_OUTPUT",
  logSafe: { outputId: true },
  create: (payload: { outputId: OutputId }) => payload,
  apply: (previousState, { outputId }) => {
    const warnings: string[] = [];

    if (previousState.outputs[outputId] == null) {
      warnings.push(`Output not found: ${outputId}`);
    }

    for (const outputContent of Object.values(previousState.outputContents)) {
      if (outputContent.outputId === outputId) {
        delete previousState.outputContents[outputContent.id];
      }
    }

    delete previousState.outputs[outputId];

    return { warnings };
  },
});
